import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { DOCUMENT_TYPE_ALIASES_ACTION_TYPE } from '../actions';

const initialState = {};

const documentTypeAliasesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case DOCUMENT_TYPE_ALIASES_ACTION_TYPE.GET_DOCUMENT_TYPE_ALIASES:
        return payload || initialState;

      case DOCUMENT_TYPE_ALIASES_ACTION_TYPE.CREATE_DOCUMENT_TYPE_ALIAS:
        draft[payload.id] = payload;
        break;

      case DOCUMENT_TYPE_ALIASES_ACTION_TYPE.DELETE_DOCUMENT_TYPE_ALIAS:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default documentTypeAliasesReducer;
